import React from 'react';
import { Tooltip } from 'UI';
import cn from 'classnames';
import {TRIAL, FREE} from 'Types/plan';
import {confirm} from 'UI';
import {useModal} from 'App/components/Modal';
import PaymentInformation from 'App/components/Client/Billing/PaymentInformation';
import {observer} from "mobx-react-lite";
import {useStore} from "@/mstore";
import { Button } from 'antd'

const TrialNotification = ({className = ''}: any) => {
    const {billingStore, userStore} = useStore();
    //     plan: state.getIn([ 'user', 'account', 'plan' ]),
//     hasActivePlan: state.getIn(['plans', 'instance', 'hasActivePlan']),
//     loading: state.getIn(['plans', 'enableBillingRequest', 'loading']),

    const plan = userStore.account.plan || {};
    const hasActivePlan = billingStore.instance?.hasActivePlan;
    const loading = billingStore.loading;

    const {showModal, hideModal} = useModal();

    const showBillingModal = () => {
        showModal(<PaymentInformation onClose={hideModal}/>, {right: true});
    }

    const trialMessage = () => {
        // plan is on trial, check for the remaining days
        if (plan.type === TRIAL) {
            if (plan.remainingTrialDays && plan.remainingTrialDays > 0) return `Your Trial Expires In ${plan.remainingTrialDays} Day(s)`;

            return 'Your Trial has expired';
        }

        if (plan.type === FREE) {
            return 'You do not have any active plan.';
        }
    };

    return !hasActivePlan ? (
        <React.Fragment>
            <div className={cn(className, 'flex items-center')}>
                {(plan.type === TRIAL || (plan.type === FREE && !plan.billingSetup)) && (
                    <Tooltip title={trialMessage()} placement="top">
                        <Button variant="primary" onClick={() => showBillingModal()}>
                            Setup Billing
                        </Button>
                    </Tooltip>
                )}
                {plan.type === FREE && plan.billingSetup && (
                    <Button
                        loading={loading}
                        type="primary"
                        size="small"
                        onClick={async () => {
                            if (
                                await confirm({
                                    header: 'Subscription',
                                    confirmation: `Are you sure to upgrade to the pay-as-you-go plan?`,
                                })
                            ) {
                                void billingStore.enablePlan();
                            }
                        }}
                    >
                        Upgrade
                    </Button>
                )}
            </div>
        </React.Fragment>
    ) : <></>;
};

export default observer(TrialNotification);

// export default connect((state: any) => ({
//     plan: state.getIn([ 'user', 'account', 'plan' ]),
//     hasActivePlan: state.getIn(['plans', 'instance', 'hasActivePlan']),
//     loading: state.getIn(['plans', 'enableBillingRequest', 'loading']),
// }), {
//     enableBilling,
// })(TrialNotification);
